import type { MenuItemsConfig } from "./MenuItems.d";

export const PRICING_PLANS_ANCHOR = "pricing-plans";
export const FEATURES_ANCHOR = "features";
export const REVIEWS_ANCHOR = "reviews";
export const FAQ_ANCHOR = "faq";

export const menuLinkConfig: Array<MenuItemsConfig> = [
  {
    href: `#${FEATURES_ANCHOR}`,
    title: "menu_features",
  },
  {
    href: `#${PRICING_PLANS_ANCHOR}`,
    title: "menu_pricing",
  },
  {
    href: `#${REVIEWS_ANCHOR}`,
    title: "menu_reviews",
  },
  {
    href: `#${FAQ_ANCHOR}`,
    title: "menu_faq",
  },
];
